/**
 * Los números, escritos en el idioma de quien mira.
 *
 * `1234` se escribe «1.234» en castellano y «1,234» en inglés: el separador de
 * miles es distinto, y un panel que enseñe un idioma con los números del otro se
 * lee mal antes de que nadie sepa decir por qué.
 *
 * Existe porque el panel llevaba `toLocaleString('es-MX')` escrito a mano en una
 * decena de sitios. Eso es de lo que ningún linterna de traducción ve —no es
 * texto, es un idioma clavado en el código—, así que sólo se arregla si hay un
 * único sitio donde escribirlo.
 *
 * El idioma sale de `activeLanguage()` y no de un parámetro por lo mismo que en
 * `dates.ts`: esto se llama desde celdas de tabla y funciones sueltas que no son
 * componentes y no pueden usar un hook.
 */
import { activeLanguage } from './i18n'

/** `1.234` · `1,234`. */
export function formatNumber(value: number, options?: Intl.NumberFormatOptions): string {
  return new Intl.NumberFormat(activeLanguage(), options).format(value)
}
